import { render, staticRenderFns } from "./CurriculumSyllabusEEC.vue?vue&type=template&id=5f866c62&scoped=true&"
import script from "./CurriculumSyllabusEEC.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusEEC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f866c62",
  null
  
)

export default component.exports